// Translations for PetalFinder
export const translations = {
  es: {
    // Header
    appName: "PetalFinder",
    appTagline: "Fichas de valor con productos FloraLife®",
    viewAllProducts: "Ver todos los productos",
    
    // Hero
    heroTitle: "Identifica flores con productos profesionales",
    heroDescription: "Sube una imagen y obtén fichas completas con recomendaciones de productos FloraLife® para cada etapa: hidratación, almacenamiento, distribución y acabados finales.",
    
    // Upload Zone
    dragImageHere: "Arrastra tu imagen aquí",
    clickToSelect: "o haz clic para seleccionar un archivo",
    acceptedFormats: "Formatos aceptados: PNG, JPG, WEBP",
    takePhoto: "Tomar foto",
    chooseFromGallery: "Elegir de galería",
    orDragHere: "o arrastra una imagen aquí",
    
    // Results
    valueCards: "Fichas de Valor",
    noResultsYet: "Sin resultados aún",
    noResultsDescription: "Sube una imagen para obtener fichas con productos FloraLife®",
    noFlowersFound: "No se identificaron flores o follajes en esta imagen.",
    
    // Buttons
    analyze: "Analizar",
    analyzing: "Analizando...",
    newImage: "Nueva",
    
    // Badges
    availableColors: "Colores disponibles",
    vasLife: "Vida en florero",
    floraLifeProducts: "Productos FloraLife®",
    care: "Cuidados",
    
    // Flower Card
    commercialSynonyms: "Sinónimos comerciales",
    availableColorsLabel: "Colores Disponibles",
    season: "Temporada",
    vasLifeLabel: "Vida en Florero",
    ethyleneSensitivity: "Sensibilidad al Etileno",
    recommendedSubstitutes: "Sustitutos Recomendados",
    ifNotFound: "Si no encuentras",
    youCanUse: ", puedes usar:",
    floraLifeRecommended: "Productos FloraLife® Recomendados",
    viewLessDetails: "Ver menos detalles",
    viewCareAndRisks: "Ver cuidados y riesgos",
    
    // Product Tabs
    hydration: "Hidratación",
    storage: "Almacenamiento",
    distribution: "Distribución",
    finishing: "Acabados",
    usage: "Uso:",
    
    // Care Sections
    vasLifeFactors: "Factores de Vida en Florero",
    postHarvestCare: "Cuidados Postcosecha",
    stemCut: "Recorte de tallo",
    foliageCleaning: "Limpieza de follaje",
    hydrationLabel: "Hidratación",
    compatibleInArrangements: "Compatibles en arreglos:",
    handlingRisks: "Riesgos de Manipulación",
    wilting: "Marchitez",
    staining: "Manchado",
    dehydration: "Deshidratación",
    gardenGuide: "Guía de Jardín",
    light: "Luz",
    watering: "Riego",
    soil: "Suelo",
    bloomingSeason: "Floración",
    pestsAndDiseases: "Plagas y Enfermedades",
    
    // Types
    flower: "flor",
    foliage: "follaje",
    
    // Footer
    developedWith: "Desarrollado con IA para floristas profesionales",
    knowAllProducts: "Conoce todos los productos FloraLife®",
    
    // Toasts
    imageLoaded: "Imagen cargada correctamente",
    invalidImage: "Por favor, sube una imagen válida (PNG, JPG, WEBP)",
    selectImageFirst: "Por favor, selecciona una imagen primero",
    elementsIdentified: "elementos con productos recomendados",
    analysisError: "Error al analizar la imagen. Intenta de nuevo.",
    processingError: "Error al procesar la imagen",
    
    // Loading
    generatingCards: "Generando fichas con productos FloraLife®",
    
    // Download
    downloadCard: "Descargar ficha",
    downloadAll: "Descargar todas",
    downloading: "Descargando...",
    downloadSuccess: "Ficha descargada correctamente",
    downloadError: "Error al descargar la ficha",
    
    // AI Prompt
    aiLanguage: "español",

    // PWA Install
    installApp: "Instalar app",
    installTitle: "Instala PetalFinder",
    installDesc: "Añádela a tu pantalla de inicio para acceso rápido y uso sin conexión.",
    installNow: "Instalar",
    installLater: "Ahora no",
    iosInstallHint: "Para instalar: toca el botón Compartir y luego «Añadir a pantalla de inicio»."
  },
  
  en: {
    // Header
    appName: "PetalFinder",
    appTagline: "Value cards with FloraLife® products",
    viewAllProducts: "View all products",
    
    // Hero
    heroTitle: "Identify flowers with professional products",
    heroDescription: "Upload an image and get complete cards with FloraLife® product recommendations for each stage: hydration, storage, distribution, and final finishing.",
    
    // Upload Zone
    dragImageHere: "Drag your image here",
    clickToSelect: "or click to select a file",
    acceptedFormats: "Accepted formats: PNG, JPG, WEBP",
    takePhoto: "Take photo",
    chooseFromGallery: "Choose from gallery",
    orDragHere: "or drag an image here",
    
    // Results
    valueCards: "Value Cards",
    noResultsYet: "No results yet",
    noResultsDescription: "Upload an image to get cards with FloraLife® products",
    noFlowersFound: "No flowers or foliage identified in this image.",
    
    // Buttons
    analyze: "Analyze",
    analyzing: "Analyzing...",
    newImage: "New",
    
    // Badges
    availableColors: "Available colors",
    vasLife: "Vase life",
    floraLifeProducts: "FloraLife® Products",
    care: "Care",
    
    // Flower Card
    commercialSynonyms: "Commercial synonyms",
    availableColorsLabel: "Available Colors",
    season: "Season",
    vasLifeLabel: "Vase Life",
    ethyleneSensitivity: "Ethylene Sensitivity",
    recommendedSubstitutes: "Recommended Substitutes",
    ifNotFound: "If you can't find",
    youCanUse: ", you can use:",
    floraLifeRecommended: "Recommended FloraLife® Products",
    viewLessDetails: "View less details",
    viewCareAndRisks: "View care and risks",
    
    // Product Tabs
    hydration: "Hydration",
    storage: "Storage",
    distribution: "Distribution",
    finishing: "Finishing",
    usage: "Usage:",
    
    // Care Sections
    vasLifeFactors: "Vase Life Factors",
    postHarvestCare: "Post-Harvest Care",
    stemCut: "Stem cutting",
    foliageCleaning: "Foliage cleaning",
    hydrationLabel: "Hydration",
    compatibleInArrangements: "Compatible in arrangements:",
    handlingRisks: "Handling Risks",
    wilting: "Wilting",
    staining: "Staining",
    dehydration: "Dehydration",
    gardenGuide: "Garden Guide",
    light: "Light",
    watering: "Watering",
    soil: "Soil",
    bloomingSeason: "Blooming",
    pestsAndDiseases: "Pests and Diseases",
    
    // Types
    flower: "flower",
    foliage: "foliage",
    
    // Footer
    developedWith: "Developed with AI for professional florists",
    knowAllProducts: "Discover all FloraLife® products",
    
    // Toasts
    imageLoaded: "Image loaded successfully",
    invalidImage: "Please upload a valid image (PNG, JPG, WEBP)",
    selectImageFirst: "Please select an image first",
    elementsIdentified: "elements with recommended products",
    analysisError: "Error analyzing image. Please try again.",
    processingError: "Error processing image",
    
    // Loading
    generatingCards: "Generating cards with FloraLife® products",
    
    // Download
    downloadCard: "Download card",
    downloadAll: "Download all",
    downloading: "Downloading...",
    downloadSuccess: "Card downloaded successfully",
    downloadError: "Error downloading card",
    
    // AI Prompt
    aiLanguage: "English",

    // PWA Install
    installApp: "Install app",
    installTitle: "Install PetalFinder",
    installDesc: "Add it to your home screen for quick access and offline use.",
    installNow: "Install",
    installLater: "Not now",
    iosInstallHint: "To install: tap the Share button, then \"Add to Home Screen\"."
  },
  
  pt: {
    // Header
    appName: "PetalFinder",
    appTagline: "Fichas de valor com produtos FloraLife®",
    viewAllProducts: "Ver todos os produtos",
    
    // Hero
    heroTitle: "Identifique flores com produtos profissionais",
    heroDescription: "Envie uma imagem e obtenha fichas completas com recomendações de produtos FloraLife® para cada etapa: hidratação, armazenamento, distribuição e acabamentos finais.",
    
    // Upload Zone
    dragImageHere: "Arraste sua imagem aqui",
    clickToSelect: "ou clique para selecionar um arquivo",
    acceptedFormats: "Formatos aceitos: PNG, JPG, WEBP",
    takePhoto: "Tirar foto",
    chooseFromGallery: "Escolher da galeria",
    orDragHere: "ou arraste uma imagem aqui",
    
    // Results
    valueCards: "Fichas de Valor",
    noResultsYet: "Sem resultados ainda",
    noResultsDescription: "Envie uma imagem para obter fichas com produtos FloraLife®",
    noFlowersFound: "Nenhuma flor ou folhagem identificada nesta imagem.",
    
    // Buttons
    analyze: "Analisar",
    analyzing: "Analisando...",
    newImage: "Nova",
    
    // Badges
    availableColors: "Cores disponíveis",
    vasLife: "Vida no vaso",
    floraLifeProducts: "Produtos FloraLife®",
    care: "Cuidados",
    
    // Flower Card
    commercialSynonyms: "Sinônimos comerciais",
    availableColorsLabel: "Cores Disponíveis",
    season: "Temporada",
    vasLifeLabel: "Vida no Vaso",
    ethyleneSensitivity: "Sensibilidade ao Etileno",
    recommendedSubstitutes: "Substitutos Recomendados",
    ifNotFound: "Se não encontrar",
    youCanUse: ", você pode usar:",
    floraLifeRecommended: "Produtos FloraLife® Recomendados",
    viewLessDetails: "Ver menos detalhes",
    viewCareAndRisks: "Ver cuidados e riscos",
    
    // Product Tabs
    hydration: "Hidratação",
    storage: "Armazenamento",
    distribution: "Distribuição",
    finishing: "Acabamentos",
    usage: "Uso:",
    
    // Care Sections
    vasLifeFactors: "Fatores de Vida no Vaso",
    postHarvestCare: "Cuidados Pós-Colheita",
    stemCut: "Corte do caule",
    foliageCleaning: "Limpeza da folhagem",
    hydrationLabel: "Hidratação",
    compatibleInArrangements: "Compatíveis em arranjos:",
    handlingRisks: "Riscos de Manuseio",
    wilting: "Murcha",
    staining: "Manchas",
    dehydration: "Desidratação",
    gardenGuide: "Guia de Jardim",
    light: "Luz",
    watering: "Rega",
    soil: "Solo",
    bloomingSeason: "Floração",
    pestsAndDiseases: "Pragas e Doenças",
    
    // Types
    flower: "flor",
    foliage: "folhagem",
    
    // Footer
    developedWith: "Desenvolvido com IA para floristas profissionais",
    knowAllProducts: "Conheça todos os produtos FloraLife®",
    
    // Toasts
    imageLoaded: "Imagem carregada com sucesso",
    invalidImage: "Por favor, envie uma imagem válida (PNG, JPG, WEBP)",
    selectImageFirst: "Por favor, selecione uma imagem primeiro",
    elementsIdentified: "elementos com produtos recomendados",
    analysisError: "Erro ao analisar imagem. Tente novamente.",
    processingError: "Erro ao processar imagem",
    
    // Loading
    generatingCards: "Gerando fichas com produtos FloraLife®",
    
    // Download
    downloadCard: "Baixar ficha",
    downloadAll: "Baixar todas",
    downloading: "Baixando...",
    downloadSuccess: "Ficha baixada com sucesso",
    downloadError: "Erro ao baixar ficha",
    
    // AI Prompt
    aiLanguage: "Portuguese (Brazil)",

    // PWA Install
    installApp: "Instalar app",
    installTitle: "Instale o PetalFinder",
    installDesc: "Adicione à tela inicial para acesso rápido e uso offline.",
    installNow: "Instalar",
    installLater: "Agora não",
    iosInstallHint: "Para instalar: toque no botão Compartilhar e em \"Adicionar à Tela de Início\"."
  }
};

export const languageNames = {
  es: "Español",
  en: "English", 
  pt: "Português"
};

export const languageFlags = {
  es: "🇲🇽",
  en: "🇺🇸",
  pt: "🇧🇷"
};
